/**
 * 判断是否虚商模式
 * @returns
 */
export function isVirtualUser() {
    return window.ISXSCONSOLE;
}
